import BaseService from './baseService';

export default class DownloadsService extends BaseService {
    constructor() {
        super('downloads');
    }

    /**
    * Gets a link to download installers
    * @param {Object} params
    * @param {number} params.app - cli or plink
    * @param {number} params.os - os name
    * @returns Link
    */
    downloads = ({ app, os }: { app: number; os: number }) => this.httpGetRequest(`?${this.generateQueryString({ app, os })}`);
}